import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/outlet`;

class OutletUsersServices {
  async getAllOutletuserData(page, limit, filter) {
    try {
      let action =
        API_ROUTE +
        `/get-all_outlet-users?page=${page}&limit=${limit}&filter=${filter}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.error("Error in getAllOutletuserData:", error);
      throw error;
    }
  }

  async addOutletUserData(payload) {
    try {
      let action = API_ROUTE + `/add-outlet_user-data`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Error in addOutletUserData:", error);
      throw error;
    }
  }

  async updateOutletUserData(payload) {
    try {
      let action = API_ROUTE + `/update-outlet_user-data`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.error("Error in updateOutletUserData:", error);
      throw error;
    }
  }
  
  async deleteOutletUser(userId) {
    try {
      let action = API_ROUTE + `/delete-outlet_user-data?id=${userId}`;
      const response = await requestToken.del(action);
      return response;
    } catch (error) {
      console.error("Error in deleteOutletUser:", error);
      throw error;
    }
  }

  async toggleOutletStatus(payload) {
    try {
      const action = API_ROUTE + "/update-outlet-user-status";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async addOutletWalletBalanceBySA(payload) {
    try {
      const action = API_ROUTE + "/update-outlet-wallet";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async unblockOutletUser(payload) {
    try {
      const action = API_ROUTE + "/unblock-outlet-user";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async assignTemplate(payload) {
    try {
      const action = API_ROUTE + "/assign-template";
      return await requestToken.post(action, payload);
    } catch (error) {
      throw error;
    }
  }
}

export default OutletUsersServices;
